<template>
  <div>
    <label>Extended Leave / Vacation: </label>
    <input-button-list
      :value="[onVacation]"
      :allow-two-stack="false"
      :multiple="false"
      label=""
      :force-full-width-inputs="false"
      :options="[{ id: 'false', display_label: 'Disabled' },{ id: 'true', display_label: 'Extended Leave / Vacation' }]"
      @input="handleVacationToggle($event)"
    />
    <div class="vacation">
      <form-component>
        <div v-show="vacationEnabled" class="form-row">
          <div class="col-12 col-md-6">
            <input-datepicker
              id="VacationStartDate"
              v-model="vacation.start"
              :value="vacation.start"
              name="VacationStartDate"
              label="Start:"
              type="text"
              :disabled="!vacationEnabled"
              :disabled-dates="{ to: moment().toDate() }"
            />
          </div>
          <div class="col-12 col-md-6">
            <input-datepicker
              id="VacationReturnDate"
              v-model="vacation.return"
              :value="vacation.return"
              name="VacationReturnDate"
              label="Return:"
              type="text"
              :disabled="!vacationEnabled"
              :disabled-dates="{ to: moment().toDate() }"
            />
          </div>
          <div v-show="!persistedVacation" class="col-12 offset-md-6 col-md-6">
            <b-button
              block
              :disabled="!vacation.start || !vacation.return || persistedVacation"
              variant="primary"
              class="w-100"
              @click="setVacation()"
            >
              <font-awesome-icon
                v-if="saving"
                :spin="true"
                :icon="['fas', 'spinner']"
                class="icon alt"
              />
              <span v-else>Confirm Vacation</span>
            </b-button>
          </div>
        </div>
      </form-component>
    </div>
  </div>
</template>

<script>
import InputButtonList from '@/components/inputs/InputButtonList.vue';
import InputDatepicker from '@/components/inputs/InputDatepicker.vue';
import FormComponent from '@/components/FormComponent.vue';
import CounselorClient from '@/api/CounselorClient';
import moment from 'moment'

export default {
    name: 'VacationPicker',

    components: {
        InputButtonList,
        InputDatepicker,
        FormComponent
    },
    props: {
        counselorId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            counselorClient: new CounselorClient(this.$http),
            onVacation: 'false',
            moment: moment,
            vacation: {
                start: '',
                return: ''
            },
            persistedVacation: false,
            saving: false,
            confirmed: false
        }
    },
    computed: {
    vacationEnabled() {
      return this.onVacation === 'true';
    }
  },
    async mounted() {
        await this.counselorClient.getCounselorVacation(this.counselorId).then(res => {
        if (res.startDate && res.endDate) {
            this.vacation.start = `${res.startDate} 00:00:00`;
            this.vacation.return = `${res.endDate} 00:00:00`;
            this.onVacation = 'true';
            this.persistedVacation = true;
        } else {
            this.onVacation = 'false';
        }
      });
    },
    methods: {
        async handleVacationToggle(event) {
            this.onVacation = event[0];
            this.vacation.start = null;
            this.vacation.return = null;
            this.persistedVacation = false;

            if (this.onVacation == 'false') {
                await this.setVacation();
            }
        },
        async setVacation() {
            this.saving = true;
            const start = this.vacation.start ? moment(this.vacation.start).format('YYYY-MM-DD') : null;
            const end = this.vacation.return ? moment(this.vacation.return).format('YYYY-MM-DD') : null;

            if (start > end) {
                this.saving = false;
                return;
            }

            await this.counselorClient.setCounselorVacation(this.counselorId, start, end).then(() => {
                this.saving = false;
                this.persistedVacation = true;
            }).catch(e => {
                console.error(e);
                this.$store.commit('setGlobalAlert', {
                    msg: 'Failed to set vacation. Please try again!',
                    error: true
                });
            });
        }
    }
}
</script>

<style lang="scss" scoped>

label {
    @include label;

    display: block;
    margin-bottom: 10px;
  }

</style>
